import apiBase from "../../api/axios";
import Cookies from "js-cookie";

/**
 * Registro público de estudiantes — no requiere autenticación.
 * POST /api/v1/registro/
 * Guarda los tokens JWT en cookies automáticamente (igual que el login).
 * @param {{ email, nombres, apellido_paterno, apellido_materno, password, password2, fecha_nacimiento }} payload
 * @returns {{ message, tokens, user }}
 */
export const registroPublicoService = async (payload) => {
  const response = await apiBase.post("v1/registro/", payload);
  // La API responde:
  // - Con verificación de email: { message, data: { message, email_verified, user } }
  // - Sin verificación:       { message, data: { tokens, user } }
  const data = response.data.data || response.data;
  const { tokens } = data;

  const isProduction = process.env.NODE_ENV === "production";

  if (tokens?.access) {
    Cookies.set("access_token", tokens.access, {
      expires: 1,
      secure: isProduction,
      sameSite: isProduction ? "strict" : "lax",
    });
  }
  if (tokens?.refresh) {
    Cookies.set("refresh_token", tokens.refresh, {
      expires: 7,
      secure: isProduction,
      sameSite: isProduction ? "strict" : "lax",
    });
  }

  return data;
};
